<template>
  <BaseContainer :title="title" :closeRefresh="true" @cancel="closeModal">
    <a-spin :spinning="pending">
      <div class="w-full h-full flex gap-x-[10px] bg-back-0 rounded-[12px]">
        <template v-if="!paySucc">
          <div class="flex flex-1 flex-col p-[24px] gap-[28px]">
            <div class="auth-type">
              <div class="auth-type-title flex items-center">
                {{ $t('ge-ren-shang-yong-shou-quan') }}
                <authorization-differences v-slot="{ show }">
                  <iconpark-icon
                    name="info-fill"
                    size="16"
                    class="mt-[4px] cursor-pointer text-[var(--text-1)] ml-[4px]"
                    @click="show"
                  />
                </authorization-differences>
              </div>
              <div class="auth-type-desc">
                {{
                  $t(
                    'jin-xian-ge-ren-shi-yong-bu-ke-yong-yu-qi-ye-shang-shi-huo-dong'
                  )
                }}
              </div>
              <div class="buy-enterprise-type" @click="onSubscribe">
                <span class="mr-[4px] font-[600]">
                  {{ $t('wo-yao-gou-mai-qi-ye-shang-yong-tao-can') }}
                </span>
                <iconpark-icon name="arrowright" size="16"></iconpark-icon>
              </div>
            </div>

            <div v-for="right in rights" :key="right.id" class="upgrade-right">
              <div class="text-[14px] text-font-1 flex">
                <span class="font-bold"> {{ right.rights_name }} </span>
                <a
                  class="ml-[8px] inline-flex justify-center items-center standard"
                  @click="handleShowRightsDesc"
                >
                  {{ $t('cha-kan-wan-zheng-quan-yi-dui-bi') }}
                  <iconpark-icon name="arrowright"></iconpark-icon>
                </a>
              </div>
              <div class="fees-grid">
                <Fees
                  v-for="f in displayFees"
                  :key="f.id"
                  :fees="f"
                  :isUpgrade="true"
                  :selected="f.id === currentFee?.id"
                  :discount="undefined"
                  @on-select="(f) => onSelectFees(f, right)"
                />
              </div>
              <div class="changed-benefits">
                <div class="changed-benefits__title flex">
                  {{ $t('sheng-ji-hou-quan-yi-bian-hua') }}
                  <a-popover>
                    <template #content>
                      <div v-if="currentFee" class="formula mt-[16px]">
                        <div class="formula-description flex items-center">
                          {{ $t('tao-can-sheng-ji-cha-jia-ji-suan-gong-shi') }}
                          = ({{ $t('sheng-ji-hou-tao-can-jia-ge') }} -
                          {{ $t('dang-qian-tao-can-jia-ge') }}) x
                          <div class="ml-[12px] text-center">
                            {{ $t('tao-can-sheng-yu-tian-shu') }}
                            <div class="h-[1px] bg-[#f1f1f1]"></div>
                            {{ $t('sheng-ji-hou-tao-can-tian-shu') }}
                          </div>
                        </div>
                        <div class="formula-value mt-[12px] flex items-center">
                          {{ $t('dang-qian-tao-can-sheng-ji-cha-jia') }} = (
                          {{
                            currentFee!.upgrade_desc![0].to_rights_price / 100
                          }}
                          -
                          {{
                            currentFee!.upgrade_desc![0].from_rights_price / 100
                          }}
                          ) x
                          <div class="ml-[12px] text-center">
                            {{
                              currentFee!.upgrade_desc![0].to_rights_remain_days
                            }}
                            <div class="h-[1px] bg-[#f1f1f1]"></div>
                            {{ currentFee!.upgrade_desc![0].to_rights_days }}
                          </div>
                        </div>
                        <div class="formula-description flex items-center">
                          {{
                            $t('tao-can-sheng-ji-bu-fa-yan-bi-ji-suan-gong-shi')
                          }}
                          = ({{ $t('sheng-ji-hou-tao-can-yan-bi-shu-liang') }} -
                          {{ $t('dang-qian-tao-can-yan-bi-shu-liang') }}) x
                          <div class="ml-[12px] text-center">
                            {{ $t('tao-can-sheng-yu-tian-shu') }}
                            <div class="h-[1px] bg-[#f1f1f1]"></div>
                            {{ $t('sheng-ji-hou-tao-can-tian-shu') }}
                          </div>
                        </div>
                        <div class="formula-value mt-[12px] flex items-center">
                          {{ $t('dang-qian-bu-fa-yan-bi') }} = (
                          {{ toCredit }} - {{ fromCredit }}
                          ) x
                          <div class="ml-[12px] text-center">
                            {{
                              currentFee!.upgrade_desc![0].to_rights_remain_days
                            }}
                            <div class="h-[1px] bg-[#f1f1f1]"></div>
                            {{ currentFee!.upgrade_desc![0].to_rights_days }}
                          </div>
                        </div>
                      </div>
                    </template>
                    <div class="title-formula ml-[4px]">
                      {{ $t('ji-suan-gong-shi') }}
                      <iconpark-icon name="info-foonpo2l"></iconpark-icon>
                    </div>
                  </a-popover>
                </div>
                <div class="changed-benefits__content">
                  <div class="changed-benefits__item">
                    <Resource
                      :src="getFeUrl('/assets/credit.png')"
                      class="h-[32px] w-[32px] mr-[4px]"
                    />
                    <span>{{ $t('yan-bi') }}</span>
                    <span class="number ml-[6px]">
                      +{{ currentFee?.upgrade_desc?.[0]?.credit_coin }}
                    </span>
                  </div>
                  <div class="changed-benefits__item">
                    <Resource
                      :src="getFeUrl('/assets/video.png')"
                      class="h-[32px] w-[32px] mr-[4px]"
                    />
                    {{ $t('dan-tiao-shi-pin-shang-xian') }}
                    <span class="mx-[4px] number">
                      {{ fromTime }}
                    </span>
                    {{ $t('fen-zhong') }}
                    <Resource
                      class="w-[10px] h-[12px] mx-[3px]"
                      :src="getFeUrl('/assets/icon-upgrade.png')"
                    />
                    <span class="mx-[4px] number">
                      {{ toTime }}
                    </span>
                    {{ $t('fen-zhong') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="w-[1px] bg-[#f1f1f1]"></div>
          <div class="flex w-[270px]">
            <PayQrcode
              v-model:agreement-checked="agreementChecked"
              v-model:payType="payType"
              :loading="false"
              :buy-type="currentFee?.buy_type"
              :qrcode="qrcode"
              :expired-date="expiredDateRange"
              :priceText="currentFee?.upgrade_price || 0"
              :reorder="createOrder"
            />
          </div>
        </template>
        <template v-else>
          <div class="w-full">
            <PaySucc
              :title="paySuccTitle"
              :desc="paySuccDesc"
              :invite-props="{
                isInviteUser,
                award: inviterAward,
                cb: goInvite,
              }"
            >
            </PaySucc>
            <div class="bar w-[92%] mx-auto h-[1px] bg-back-3"></div>
            <PaySuccTip class="my-[28px]" :url="getQrcodeURI('c', '3')" />
          </div>
        </template>
      </div>
    </a-spin>
  </BaseContainer>
</template>

<script setup lang="ts" name="BuyEquity">
import { getI18nService } from '@rendora/common/services/i18n/index'
import dayjs from 'dayjs'
import { type IEquity } from '~/api/interface'
import { BUY_TYPE, ORDER_BEHAVIOR, type IFees } from '~/api/interface/rights'
import { getOrderUpgradePrice } from '~/api/module/order'
import { PageKey } from '~/constants/page'
import { clearModals } from '~/hooks/useModal/modals/empty'
import Fees from '~/pages/center/equity/components/fees.vue'
import { getFeUrl, getQrcodeURI } from '~/utils/url'
import BaseContainer from '../../components/baseContainer/index.vue'
import useCheckUserInvited from '../../useCheckUserInvited'
import useOrder from '../../useOrder'
import PayQrcode from '../pay-qrcode.vue'
import PaySuccTip from '../pay-succ-tip.vue'
import PaySucc from '../pay-succ.vue'
import AuthorizationDifferences from './authorization-differences.vue'

const props = defineProps<{
  onCancel: () => void
}>()

const userInfo = useUserInfo()
const { t: $t } = getI18nService()

const pending = ref(false)
const currentFee = ref<IFees | null>(null)
const currentRight = ref<IEquity | null>(null)
const rights = ref<IEquity[]>([])

const fromTime = computed(() => {
  if (!currentFee.value) {
    return
  }
  const t = currentFee.value?.upgrade_desc?.[0].from_single_video_max_duration
  return t ? Math.ceil(t / 60) : 0
})

const toTime = computed(() => {
  const t = currentFee.value?.upgrade_desc?.[0].to_single_video_max_duration
  return t ? Math.ceil(t / 60) : 0
})

const toCredit = computed(() => {
  const upgrade_desc = currentFee.value?.upgrade_desc?.[0]
  const v = upgrade_desc?.to_credit_coin
  return v || 0
})

const fromCredit = computed(() => {
  const upgrade_desc = currentFee.value?.upgrade_desc?.[0]
  const v = upgrade_desc?.from_credit_coin
  return v || 0
})

const orderBody = computed(() => {
  return {
    buy_type: currentFee.value?.buy_type,
    behavior: ORDER_BEHAVIOR.UPGRADE,
    rights_type: currentRight.value?.rights_type,
    rights_id: currentFee.value?.id,
    time_identity: currentFee.value?.time_identity,
  }
})

const paySuccTitle = computed(
  () => formatPrice(currentFee.value?.upgrade_price || 0).string
)

const paySuccDesc = computed(() => {
  const payAction = (() => {
    if (currentFee.value?.buy_type === BUY_TYPE.PAYMENT) {
      return currentFee.value.days === 30 ? $t('dan-yue') : $t('dan-nian')
    }
    return currentFee.value?.days === 30
      ? $t('lian-xu-bao-yue')
      : $t('lian-xu-bao-nian')
  })()

  return `${currentRight.value?.rights_name} ${payAction}`
})

const { isInviteUser, inviterAward } = useCheckUserInvited(currentFee as any)

function goInvite() {
  const router = useRouter()
  router.push({ name: PageKey.PULL_NEW })
}

const { agreementChecked, qrcode, paySucc, createOrder, payType } =
  useOrder(orderBody)

const title = computed(() => {
  return $t('sheng-ji') + currentRight.value?.rights_name
})

const displayFees = computed(() => {
  return currentRight.value?.rights_by_time
})

const onSelectFees = (f: IFees, r: IEquity) => {
  currentRight.value = r
  currentFee.value = f
}

const expiredDateRange = computed(() => {
  const endDate = dayjs(userInfo.value?.current_package_expired_time).format(
    'YYYY.MM.DD'
  )
  const beginDate = dayjs().format('YYYY.MM.DD')

  return `${beginDate}~${endDate}`
})

function onSubscribe() {
  clearModals()
  actionUpdateCycle('team')
  navigateTo({ name: PageKey.SUBSCRIBE })
}

function handleShowRightsDesc() {
  navigateTo({ name: PageKey.SUBSCRIBE })
}

onMounted(async () => {
  pending.value = true
  const res = await getOrderUpgradePrice()
  pending.value = false
  if (res.data) {
    rights.value = res.data
    currentRight.value = rights.value[0]
    currentFee.value = displayFees.value?.[0] || null
  }
})

function closeModal() {
  props.onCancel()
}
</script>

<style lang="scss" scoped>
.title-formula {
  display: flex;
  font-size: 12px;
  font-weight: 400;
  color: var(--warning-10);
  cursor: pointer;
  iconpark-icon {
    font-size: 14px;
    color: var(--text-1);
    margin-left: 2px;
  }
}

.formula {
  font-size: 12px;
  color: var(--text-1-60);
}

.fees-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}
.auth-type {
  position: relative;
  width: 100%;
  padding: 0 0px 0px 10px;
  .auth-type-title {
    color: var(--warning-7);
    font-weight: 600;
    line-height: 20px;
  }
  .auth-type-desc {
    margin-top: 2px;
    color: var(--text-1);
    font-size: 12px;
    line-height: 20px;
  }
  .buy-enterprise-type {
    position: absolute;
    cursor: pointer;
    right: 0px;
    top: 50%;
    transform: translateY(-50%);
    height: 44px;
    border-radius: 8px;
    color: var(--warning-10);
    background-color: var(--warning-3);
    padding: 12px 16px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.changed-benefits__title {
  font-size: 14px;
  color: var(--warning-10);
  font-weight: 600;
  line-height: 20px;
  margin-top: 20px;
  margin-bottom: 12px;
}
.changed-benefits__item {
  display: inline-flex;
  background-color: var(--warning-1);
  padding-left: 8px;
  padding-right: 12px;
  border-radius: 8px;
  margin-right: 8px;
  align-items: center;
  color: var(--warning-10);
  .number {
    font-weight: 600;
  }
}
</style>
